export enum ToastMessageType {
  Success,
  Warning,
  Error,
  Information
}
